import {LookupDataRow} from "../../services/LookupDataRow";

export interface ReferenceDetails {
    lookupOptions?: (formState?: any) => LookupDataRow[];
    showFilterField?: boolean;
    lookupEntity?: LookupEntities
	lookupEntities?: LookupEntities[]
}

export enum LookupEntities {
	Customers = 'customer',
	Departments = 'department',
	Positions = 'position',
	Users = 'user',
	Employees = 'employee',
	Contacts = 'contact',
	EducationLevelTypes = 'educationLevelType',
	ContractTypes = 'contractType',
	Uploads = 'uploads',
	Tenants = 'tenant',
	Roles = 'role',
	DepartmentRoles = 'departmentRoles'
}
